import { initGraphQLTada } from "gql.tada";
import { introspection } from "./graphql-env";

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    Date: string;
    DateTime: string;
    JSON: Record<string, any>;
    BigInt: number;
    Int: number;
    Boolean: boolean;
    Decimal: string;
    SafeInt: number;
    LocalDate: string;
  };
}>();

export type { FragmentOf, ResultOf, VariablesOf } from "gql.tada";
export { readFragment } from "gql.tada";
